// js/components/ProductModel.js
import Delegate from 'ftdomdelegate';
import { Responsive } from '../utils.js';

export class ProductModel extends HTMLElement {
  constructor() {
    super();
    this.delegateElement = new Delegate(this);
    this.delegateRoot = new Delegate(document.documentElement);
    this._attachListeners();
    let stylesheet = document.createElement("link");
    stylesheet.rel = "stylesheet";
    stylesheet.href = "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css";
    document.head.appendChild(stylesheet);
    window.Shopify.loadFeatures([{
      name: "model-viewer-ui",
      version: "1.0",
      onLoad: this._setupModelViewerUI.bind(this)
    }, {
      name: "shopify-xr",
      version: "1.0"
    }]);
  }

  destroy() {
  }

  _attachListeners() {
    this.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_play", () => {
      this.dispatchEvent(new CustomEvent("model:played", { bubbles: true }));
    });
    this.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
      this.dispatchEvent(new CustomEvent("model:paused", { bubbles: true }));
    });
  }

  hasBeenSelected(isInitialLoading) {
    if (Responsive.matchesBreakpoint("supports-hover") && !isInitialLoading) {
      this.modelUi.play();
    }
  }

  hasBeenDeselected() {
    this.modelUi.pause();
  }

  _setupModelViewerUI() {
    this.modelElement = this.querySelector("model-viewer");
    this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement);
  }
}
